/* OmegaLytes PDP — interactions (Dawn-compatible, vanilla JS) */
(function () {
  'use strict';

  /* Guard: this file is included by more than one section — never init twice
     (double listeners would double-fire add-to-cart). */
  if (window.__omegalytesInit) { return; }
  window.__omegalytesInit = true;

  function drawIcons() { if (window.lucide && window.lucide.createIcons) window.lucide.createIcons(); }

  function money(cents) {
    var v = (cents / 100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  /* ---------- Gallery: swipeable scroll-snap carousel + synced thumbs ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-ol-track]');
    if (!track) return;
    var thumbs = root.querySelectorAll('[data-ol-thumb]');

    function setActive(i) {
      thumbs.forEach(function (b, n) { b.classList.toggle('active', n === i); });
      var active = thumbs[i];
      if (active && active.scrollIntoView) {
        try { active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) { /* older browsers */ }
      }
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (track.clientWidth > 0) setActive(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    }, { passive: true });
  }

  /* ---------- Cart helpers ---------- */
  function setHeaderCartCount(n) {
    document.querySelectorAll('.ol-cart').forEach(function (a) {
      var c = a.querySelector('.count');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'count'; a.appendChild(c); }
        c.textContent = n;
      } else if (c) {
        c.remove();
      }
    });
  }

  function syncHeaderCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { setHeaderCartCount(c.item_count); })
      .catch(function () {});
  }

  /* Re-render Dawn's cart drawer from the server, then slide it open */
  function refreshDawnCart() {
    var dd = document.querySelector('cart-drawer');
    if (!dd) { window.location.href = '/cart'; return; }
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer']) {
          var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = html.querySelector('cart-drawer .drawer__inner') || html.querySelector('cart-drawer');
          var cur = dd.querySelector('.drawer__inner');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          dd.classList.remove('is-empty');
        }
        if (typeof dd.open === 'function') dd.open();
      })
      .catch(function () { window.location.href = '/cart'; });
    syncHeaderCartCount();
  }

  /* Header cart icon opens the drawer instead of navigating to /cart */
  function initCartIcon(root) {
    root.querySelectorAll('.ol-cart').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var dd = document.querySelector('cart-drawer');
        if (dd && typeof dd.open === 'function') {
          e.preventDefault();
          dd.open();
        }
      });
    });
  }

  /* Keep the header count badge in sync whenever the drawer re-renders
     (quantity changes, removals) — covers all of Dawn's update paths. */
  function initCartSync() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (ev && ev.cartData && typeof ev.cartData.item_count === 'number') {
            setHeaderCartCount(ev.cartData.item_count);
          } else {
            syncHeaderCartCount();
          }
        });
      }
    } catch (e) { /* pubsub not available */ }

    var dd = document.querySelector('cart-drawer');
    if (dd && window.MutationObserver) {
      var pending;
      var mo = new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(syncHeaderCartCount, 300);
      });
      mo.observe(dd, { childList: true, subtree: true });
    }
  }

  /* Minus button at the minimum quantity removes the line item entirely
     (Dawn's quantity validation otherwise blocks going below the minimum). */
  function initCartMinusRemoves() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('.cart-drawer .quantity__button[name="minus"]');
      if (!btn) return;
      var qi = btn.closest('quantity-input');
      var input = qi ? qi.querySelector('.quantity__input') : null;
      if (!input) return;
      var min = parseInt(input.getAttribute('data-min') || '1', 10) || 1;
      if (parseInt(input.value, 10) <= min) {
        e.preventDefault();
        e.stopPropagation();
        var row = btn.closest('.cart-item');
        var rm = row ? row.querySelector('cart-remove-button button') : null;
        if (rm) rm.click();
      }
    }, true);
  }

  /* ---------- Buy box ---------- */
  function initBuyBox(root) {
    var form = root.querySelector('[data-ol-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceLabel = root.querySelector('[data-ol-atc-price]');
    var bundles = root.querySelectorAll('[data-ol-bundle]');

    function select(el) {
      bundles.forEach(function (b) { b.classList.remove('sel'); });
      el.classList.add('sel');
      if (idInput) idInput.value = el.getAttribute('data-variant-id');
      if (priceLabel) priceLabel.textContent = money(parseInt(el.getAttribute('data-price'), 10));
    }
    bundles.forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); select(el); });
    });

    /* Add to cart via AJAX, then slide open the cart drawer (no toast) */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = idInput ? idInput.value : null;
      if (!id) return;
      var btn = form.querySelector('[data-ol-atc]');
      if (btn) {
        if (btn.getAttribute('aria-busy') === 'true') return; /* prevent double-submit */
        btn.setAttribute('aria-busy', 'true');
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) btn.removeAttribute('aria-busy');
          refreshDawnCart();
        })
        .catch(function () {
          if (btn) btn.removeAttribute('aria-busy');
          window.location.href = '/cart';
        });
    });
  }

  /* ---------- FAQ accordion (one open at a time) ---------- */
  function initFaq(root) {
    var items = root.querySelectorAll('[data-ol-faq-item]');
    items.forEach(function (item) {
      var q = item.querySelector('[data-ol-faq-q]');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        items.forEach(function (i) { i.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
        drawIcons();
      });
    });
  }

  /* ---------- Timeline scroll-fill (mobile) ---------- */
  function initTimeline(root) {
    var grid = root.querySelector('[data-ol-timeline]');
    var fill = root.querySelector('[data-ol-timeline-fill]');
    if (!grid || !fill) return;
    function onScroll() {
      var r = grid.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (window.innerHeight * 0.78 - r.top) / r.height));
      fill.style.height = (p * 100) + '%';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- Announcement bar rotation ---------- */
  function initAnnouncement(root) {
    var bar = root.querySelector('[data-ol-ann]');
    if (!bar) return;
    var items = bar.querySelectorAll('[data-ol-ann-item]');
    if (items.length === 0) return;
    var i = 0;
    items.forEach(function (el, n) { el.classList.toggle('on', n === 0); });
    if (items.length < 2) return;
    setInterval(function () {
      items[i].classList.remove('on');
      i = (i + 1) % items.length;
      items[i].classList.add('on');
    }, 4000);
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    var btn = root.querySelector('[data-ol-menu-btn]');
    var nav = root.querySelector('[data-ol-mnav]');
    if (!btn || !nav) return;
    btn.addEventListener('click', function () { nav.classList.toggle('open'); });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('open'); });
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('.ol-root');
    roots.forEach(function (root) {
      initGallery(root);
      initBuyBox(root);
      initFaq(root);
      initTimeline(root);
      initAnnouncement(root);
      initMenu(root);
      initCartIcon(root);
    });
    initCartSync();
    initCartMinusRemoves();
    drawIcons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // re-draw icons once Lucide CDN finishes loading
  window.addEventListener('load', drawIcons);
})();
